import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { throwError } from "rxjs";
import { AngularAppLogger } from "../angular-app-logger";
import { SpinnerService } from "../spinner/spinner.service";
import { AppConfig } from "../shared/constants/app.config";
import { PatientImportData } from "./patient.import.data";
import { AppStateService } from '../shared/service/app.state.service';


@Component({
    selector: 'patient.import',
    templateUrl: './patient.import.component.html',
    styleUrl: './patient.import.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PatientImportComponent implements OnInit {

  patientImportData: PatientImportData = new PatientImportData();
  //appName: string;

  constructor(
    readonly route: ActivatedRoute,
    readonly appLogger: AngularAppLogger,
    readonly spinner: SpinnerService,
    readonly appState: AppStateService
  ) {}

  async ngOnInit() {
    await this.route.data.subscribe(
     (results) => {
       this.patientImportData.patientData = results.pageData;
       this.patientImportData.oktaToken = history?.state?.oktaToken ? history?.state?.oktaToken : null;
       this.patientImportData.apiURL = AppConfig.PI_API_URL;
       this.patientImportData.epicAuthToken = this.appState.getEhrAccessToken();
       this.patientImportData.issURL = localStorage.getItem("iss");
       this.patientImportData.appLogger = this.appLogger;
       this.appLogger.logInfo(
         {
           patientData: this.patientImportData.patientData,
           oktaToken: this.patientImportData.oktaToken,
           apiURL: this.patientImportData.apiURL,
           epicAuthToken: this.patientImportData.epicAuthToken,
           issURL: this.patientImportData.issURL
         },
         { context: "Successfully set PatientImportData in MSPI" }
       );
    },
    (error) => {
      this.spinner.reset();
      this.appLogger.logError(error, {context: 'Error in PatientImportComponent.ngOnInit'});
      return throwError(error);
    });
  }
}
